<div class="spinGral" [ngClass]="{'onlySpinner':onlySpinner}" *ngIf="!error">
  <div class="spinPurple" role="status">
    <img src="assets/img/spinner.gif" class="spinner-gif" alt="spinner"/>
  </div>
  <div *ngIf="!onlySpinner" class="textSpin">{{texto}}</div>
</div>
<div *ngIf="error && !onlySpinner" class="errorService">{{textoError}}</div>